export const getCurrencySymbol = (currencyCode: string): string => {
  if (!currencyCode) {
    return ''
  }

  try {
    const parts = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).formatToParts(0)

    const symbolPart = parts.find((part) => part.type === 'currency')
    return symbolPart ? symbolPart.value : ''
  } catch {
    return ''
  }
}
